/**
 * Build absolute base URL for the backend (no trailing slash), for static files under /images/...
 */
export function getApiOrigin() {
  const raw = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
  // Remove trailing /api only (avoid breaking hostnames like api.example.com)
  const stripped = raw.replace(/\/?api\/?$/, "").replace(/\/$/, "");
  return stripped || "http://localhost:5001";
}

/**
 * Resolve a stored thumbnail/image value to a full URL for <img src>.
 * Handles: full http(s) URL, paths starting with /images/, or bare filenames in uploads/products.
 */
export function resolveProductImageSrc(imageField) {
  if (imageField == null || imageField === "") return null;
  const s = String(imageField).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const base = getApiOrigin();
  if (s.startsWith("/images/")) {
    return `${base}${s}`;
  }
  // Path without leading slash, e.g. "images/products/foo.jpg"
  if (/^images\//i.test(s)) {
    return `${base}/${s.replace(/^\/+/, "")}`;
  }
  return `${base}/images/products/${s.replace(/^\/+/, "")}`;
}

/**
 * Prefer thumbnail, then legacy image field, then first gallery filename.
 */
export function getProductImageField(product) {
  if (!product) return null;
  const thumb = product.thumbnail || product.image;
  if (thumb) return thumb;
  if (!product.images) return null;
  try {
    const arr =
      typeof product.images === "string" ? JSON.parse(product.images) : product.images;
    if (Array.isArray(arr) && arr.length > 0 && arr[0]) {
      return arr[0];
    }
  } catch {
    /* ignore */
  }
  return null;
}
